<app-modal-confirmation-std4-skin [header]="'CONFIGURATION.NOTIFICATION' | translate"
  [showDismissButton]="false"
  [showSubmitButton]="false"
  (dismiss)="modalService.dismissAll()">
  <ng-template>
    <div class="text-center">
      <h2 class="f-bold-custom">{{ 'CONFIGURATION.REMAINING-TIME' | translate }}</h2>
      <div class="timer-container">
        <div class="timer"
          id="countdown">
          <countdown [config]="config"
            (event)="handleEvent($event)"></countdown>
        </div>
      </div>
      <p class="message">
        {{ 'CONFIGURATION.LOG-LOGIN' | translate }}
      </p>
    </div>
  </ng-template>
</app-modal-confirmation-std4-skin>